<template>
    <div class="container" v-if="employee">
        <div class="row center">
            <!-- <div class="col-lg-2">
                <avatar-widget
                        :color="employee.color"
                        v-model="employee.image"
                        :upload="false">
                </avatar-widget>
                <p>{{ employee.name }}</p>
                <p v-if="employee.email"><i class="icon icon-email"></i>{{ employee.email }}</p>
                <p v-if="employee.phone"><i class="icon icon-phone"></i>{{ employee.phone }}</p>
            </div> -->
            <div class="col-lg-7">
                <label>{{ $t('label.from') }}</label>
                <datepicker format="DD MMMM YYYY"
                            class="with-icon"
                            v-model="range"
                ></datepicker>
                <div v-if="visible && (employeeStats.services.length)">
                    <h3>
                        {{ $t('label.services') }}
                    </h3>
                    <doughnut :chartData="doughnutChartData" cssClasses="stats-doughnut-chart"></doughnut>
                </div>
                <div v-else>
                    <div class="no-data">
                        {{ $t('label.noDataAvailable') }}
                    </div>
                </div>
            </div>
        </div>
        <div v-if="visible && (employeeStats.appointments_count.length || employeeStats.services.length)">
            <div class="row center">
                <div class="col-lg-11 col-md-12">
                    <hr class="extra" />
                </div>
            </div>
            <div class="row around">
                <div class="col-lg-5 col-md-6">
                    <h3>
                        {{ $t('label.profit') }}: {{ formatPrice(totalProfit) }}
                    </h3>
                    <line-chart :chartData="profitChartData" cssClasses="stats-line-chart"></line-chart>
                </div>
                <div class="col-lg-5 col-md-6">
                    <h3>
                        {{ $t('label.appointments') }}: {{ totalAppointments }}
                    </h3>
                    <line-chart :chartData="appointmentsChartData" cssClasses="stats-line-chart"></line-chart>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Datepicker from '@/components/widgets/datepicker/VueDatepickerLocal'
  import _ from 'lodash'
  import Doughnut from '@/components/widgets/charts/DoughnutChart'
  import LineChart from '@/components/widgets/charts/LineChart'
  import settings from '@/services/settings'
  import Moment from 'moment'
  import {extendMoment} from 'moment-range'
  import AvatarWidget from '@/components/widgets/AvatarWidget'
  import auth from '@/auth'

  const moment = extendMoment(Moment)

  export default {
    components: {AvatarWidget, Datepicker, Doughnut, LineChart},
    name: 'EmployeeStatsPage',
    props: ['employees', 'statistics', 'from', 'to', 'visible'],
    data () {
      return {
        employee: this.getEmployee(this.$route.params.employee),
        employeeStats: this.getStats(this.$route.params.employee)
      }
    },
    watch: {
      '$route.params.employee': function (employeeId) {
        this.employee = this.getEmployee(employeeId)
        this.employeeStats = this.getStats(this.$route.params.employee)
      },
      employees () {
        this.employee = this.getEmployee(this.$route.params.employee)
      },
      statistics () {
        this.employeeStats = this.getStats(this.$route.params.employee)
      }
    },
    computed: {
      doughnutChartData () {
        let data = {
          'labels': [],
          'datasets': [
            {
              data: [],
              backgroundColor: settings.colors
            }
          ]
        }
        if (this.visible) {
          _.forEach(this.employeeStats.services, service => {
            data.labels.push(service.name)
            data.datasets[0].data.push(service.profit)
          })
          return data
        }
      },
      appointmentsChartData () {
        let data = {
          'labels': [],
          'datasets': [
            {
              label: 'Appointments',
              data: [],
              backgroundColor: 'rgba(5, 203, 225, .5)'
            }
          ]
        }
        let appointments = _.sortBy(_.unionBy(this.employeeStats.appointments_count, this.getRange(), 'date'), 'date')
        _.forEach(appointments, appointment => {
          data.labels.push(appointment.date)
          data.datasets[0].data.push(appointment.count)
        })
        return data
      },
      profitChartData () {
        let data = {
          'labels': [],
          'datasets': [
            {
              label: 'Profit',
              data: [],
              backgroundColor: 'rgba(5, 203, 225, .5)'
            }
          ]
        }
        let appointments = _.sortBy(_.unionBy(this.employeeStats.appointments_count, this.getRange(), 'date'), 'date')
        _.forEach(appointments, appointment => {
          data.labels.push(appointment.date)
          data.datasets[0].data.push(appointment.profit)
        })
        return data
      },
      range: {
        get () {
          return [
            this.from,
            this.to
          ]
        },
        set (value) {
          this.$emit('rangeChanged', value)
        }
      },
      totalProfit () {
        let total = 0
        _.forEach(this.employeeStats.services, service => {
          total += service.profit
        })
        return total
      },
      totalAppointments () {
        let total = 0
        _.forEach(this.employeeStats.appointments_count, appointment => {
          total += appointment.count
        })
        return total
      }
    },
    methods: {
      getEmployee (employeeId) {
        return _.filter(this.employees, {'id': employeeId})[0]
      },
      getStats (employeeId) {
        return _.filter(this.statistics.employees, {'id': employeeId})[0]
      },
      getRange () {
        let data = []
        let range = moment.range(this.$moment(this.from), this.$moment(this.to))
        let i = 0
        for (let day of range.by('day')) {
          data[i] = {
            date: day.format('YYYY-MM-DD'),
            count: 0,
            profit: 0
          }
          i++
        }
        return data
      },
      formatPrice (val) {
        return val + ' ' + auth.getOrganization().currency.toUpperCase()
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Organization/Stats/EmployeeStats.vue